import React, {useImperativeHandle, forwardRef, useEffect, useState, Fragment} from "react";
import {FilesManager} from "@models/gallery";
import ItemForm from '@components/video-contents/files/ItemForm';
import videoContentApi from "@api/video-content";
import {Col, Row} from "antd";


type SelectedFile = {
  video_file_id: string;
  poster_id: string;
  primary_file: boolean
}

type FilesManagerStateShape = {
  selectedItems: SelectedFile[];
  deletedItems: string[];
  updatedItems: SelectedFile[];
};


interface FilesManagerPropsShape {
  video_content_id?: string;
  isDuplicatedForm?:boolean
}

const initialState:FilesManagerStateShape = {
  selectedItems: [],
  deletedItems: [],
  updatedItems: []
}

function FilesManager(props: FilesManagerPropsShape, ref) {
  const {video_content_id} = props;
  const [state, setState] = useState(initialState);
  
  useEffect(() => {
    if (video_content_id) {
      fetchVideoFiles()
    }
  }, []);
  
  const fetchVideoFiles = () => {
    videoContentApi.getFilesList({
        params: {
          id: video_content_id
        }
      })
      .then(({data}) => {
        // @ts-ignore
        setState({
          ...state,
          selectedItems: props.isDuplicatedForm
          ? data.map(({ poster,  ...rest }) => ({
          ...rest,
            id: null,
            poster_id : poster?.id,
            poster
          }))
        : data,
        });
      })
      .catch((error) => {
        console.log(error)
      })
  };
  
  useImperativeHandle(ref, () => ({
    value: {
      ...state,
      selectedItems: state.selectedItems.map((item, index) => ({
        ...item,
        order: index
      }))
    }
  }));
  
  const onAdd = (newItem: FilesManager) => {
    // @ts-ignore
    setState({
      ...state,
      selectedItems: [...state.selectedItems, newItem]
    })
  };
  
  const onDelete = (index: number) => {
    const deletedFile = state.selectedItems[index];
    setState({
      ...state,
      deletedItems: deletedFile.id ? [...state.deletedItems, deletedFile.video_file.id] : [...state.deletedItems],
      selectedItems: [...state.selectedItems.slice(0, index), ...state.selectedItems.slice(index + 1)]
    })
  };
  
  const onEdit = (updatedIndex, data) => {
    setState({
      ...state,
      selectedItems: state.selectedItems.map( (item, index) => {
        if(index === updatedIndex){
          return{
            ...data,
            updated: true
          }
        }
        else{
          return item;
        }
      })
    });
  };
  
  return (
    <Fragment>
      <Row gutter={24}>
        {
          state.selectedItems.map((item, index) => (
            <Col span={4}>
              <ItemForm
                key={item.id}
                index={index}
                id={index}
                item={item}
                onDelete={onDelete}
                onEdit={onEdit}
              />
            </Col>
          ))
        }
      </Row>
  
      <ItemForm onAdd={onAdd} key={`add-${state.selectedItems.length + 1}th-items`}/>
    </Fragment>
  )
}

export default forwardRef(FilesManager);
